import {useEffect, useState} from "react";
import {detectMobileDevice, UTIL_FUNCTIONS} from "../utils/util-functions";

export function useIsTabletDevice() {
    const [isTabletDevice, setIsTabletDevice] = useState<boolean>(UTIL_FUNCTIONS.isTabletDevice());

    useEffect(() => {
        window.addEventListener('resize', updateIsTabletDevice);

        return () => {
            window.removeEventListener('resize', updateIsTabletDevice);
        }
    });

    const updateIsTabletDevice = () => {
        setIsTabletDevice(UTIL_FUNCTIONS.isTabletDevice());
    }

    return isTabletDevice;
}